/**
 * @author HungNS
 */
import IConstants from '@/common/constants/IConstants'

const moduleLeftMenu = {
    namespaced: true,
    state: () => ({
        menuItems : [...IConstants.leftMenuItems],
    }),
    mutations: {
        changeActiveMenuItem(state, itemName) {
            state.menuItems = state.menuItems.map(item => {
                if (item.link.name === itemName) {
                    item.active = true;
                }else {
                    item.active = false;
                }
                return item;
            });
        }
    },
    actions: {
        changeActiveMenuItem(context, itemName) {
            context.commit('changeActiveMenuItem', itemName)
        }
    },

};
export default moduleLeftMenu;
